export enum HealthDecValidationOptions {
  VALID = 'VALID',
  INVALID = 'INVALID',
  MAINTENANCE = 'MAINTENANCE',
}

interface HealthDecValidation {
  result: HealthDecValidationOptions;
}

export default HealthDecValidation;
